<script>
// Botones para entrar con un proveedor externo (SSO) en el login del
// administrador. Hoy solo Google; Microsoft se suma acá mismo.
//
// No carga nada de Google ni conoce su client id: el botón solo avisa a
// Login.vue, que manda a la persona al backend (utils/sso/redireccion.js).
//
// - Prop `deshabilitado`: true mientras hay un ingreso en curso.
// - Evento `iniciar`: { proveedor }, al hacer clic.
//
// Si el build no trae VUE_APP_SSO_BASE_URL el componente no dibuja nada, así
// el administrador puede desplegarse antes que el backend.
import { hayGoogleSso } from "@/utils/sso/redireccion";

export default {
  name: "BotonesSso",

  props: {
    deshabilitado: { type: Boolean, default: false },
  },

  data() {
    return {
      googleVisible: hayGoogleSso(),
    };
  },

  methods: {
    ingresarConGoogle() {
      if (this.deshabilitado) return;
      this.$emit("iniciar", { proveedor: "Google" });
    },
  },
};
</script>

<template>
  <div v-if="googleVisible" class="botones-sso">
    <div class="botones-sso__separador">
      <span>o</span>
    </div>
    <button
      type="button"
      class="btn btn-custom-color-white border border-round-50 mw-100 my-2"
      :disabled="deshabilitado"
      @click="ingresarConGoogle"
    >
      Ingresar con Google
    </button>
  </div>
</template>

<style scoped lang="scss">
.botones-sso {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  &__separador {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    margin-top: 4px;
    font-family: var(--font-text);
    font-size: 12px;
    color: #9ca3af;

    &::before,
    &::after {
      content: "";
      flex: 1;
      height: 1px;
      background: #e5e7eb;
    }
  }
}
</style>
